'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _VerifyStatus = require('./VerifyStatus.scss');

var _VerifyStatus2 = _interopRequireDefault(_VerifyStatus);

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  VerifyStatus: {
    displayName: 'VerifyStatus'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/LocalExpertProfile/VerifyStatus.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var VerifyStatus = _wrapComponent('VerifyStatus')((_dec = (0, _reactCssModules2.default)(_VerifyStatus2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VerifyStatus, _Component);

  function VerifyStatus() {
    (0, _classCallCheck3.default)(this, VerifyStatus);
    return (0, _possibleConstructorReturn3.default)(this, (VerifyStatus.__proto__ || (0, _getPrototypeOf2.default)(VerifyStatus)).apply(this, arguments));
  }

  (0, _createClass3.default)(VerifyStatus, [{
    key: 'render',
    value: function render() {
      return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
          'div',
          { styleName: 'flex-row' },
          _react3.default.createElement(
            'div',
            { styleName: 'verification-container' },
            _react3.default.createElement(
              'h3',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.header' })
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'flex-verification' },
          _react3.default.createElement(
            'div',
            { styleName: 'verification-column' },
            _react3.default.createElement(
              'div',
              { styleName: 'icon-box' },
              _react3.default.createElement(
                'div',
                { styleName: this.props.mobileVerified ? 'phone-icon-verified' : 'phone-icon' },
                this.props.mobileVerified && _react3.default.createElement('div', { styleName: 'verify-phone' })
              ),
              this.props.isOwner && !this.props.mobileVerified ? _react3.default.createElement(
                _Link2.default,
                { to: '/dashboard/verification' },
                _react3.default.createElement(
                  'p',
                  { styleName: 'add-text' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.phone_number' })
                )
              ) : _react3.default.createElement(
                'p',
                { styleName: 'text' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.phone_number' })
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'icon-box' },
              _react3.default.createElement(
                'div',
                { styleName: this.props.idCardVerified ? 'id-icon-verified' : 'id-icon' },
                this.props.idCardVerified && _react3.default.createElement('div', { styleName: 'verify-id' })
              ),
              this.props.isOwner && !this.props.idCardVerified ? _react3.default.createElement(
                _Link2.default,
                { to: '/dashboard/verification' },
                _react3.default.createElement(
                  'p',
                  { styleName: 'add-text' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.id_card' })
                )
              ) : _react3.default.createElement(
                'p',
                { styleName: 'text' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.id_card' })
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'verification-column' },
            _react3.default.createElement(
              'div',
              { styleName: 'icon-box' },
              _react3.default.createElement(
                'div',
                { styleName: this.props.emailVerified ? 'email-icon-verified' : 'email-icon' },
                this.props.emailVerified && _react3.default.createElement('div', { styleName: 'verify-email' })
              ),
              this.props.isOwner && !this.props.emailVerified ? _react3.default.createElement(
                _Link2.default,
                { to: '/dashboard/verification' },
                _react3.default.createElement(
                  'p',
                  { styleName: 'add-text' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.email' })
                )
              ) : _react3.default.createElement(
                'p',
                { styleName: 'text' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.email' })
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'icon-box' },
              _react3.default.createElement(
                'div',
                { styleName: this.props.socialVerified ? 'social-icon-verified' : 'social-icon' },
                this.props.socialVerified && _react3.default.createElement('div', { styleName: 'verify-social' })
              ),
              this.props.isOwner && !this.props.socialVerified ? _react3.default.createElement(
                _Link2.default,
                { to: '/dashboard/profile' },
                _react3.default.createElement(
                  'p',
                  { styleName: 'add-text' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.social' })
                )
              ) : _react3.default.createElement(
                'p',
                { styleName: 'text' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'dashboard.dashboard.verifications.social' })
              )
            )
          )
        )
      );
    }
  }]);
  return VerifyStatus;
}(_react2.Component), _class2.propTypes = {
  mobileVerified: _react2.PropTypes.bool,
  idCardVerified: _react2.PropTypes.bool,
  emailVerified: _react2.PropTypes.bool,
  socialVerified: _react2.PropTypes.bool,
  isOwner: _react2.PropTypes.bool
}, _class2.defaultProps = {
  mobileVerified: false,
  idCardVerified: false,
  emailVerified: false,
  socialVerified: false,
  isOwner: false
}, _temp)) || _class));

exports.default = VerifyStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LocalExpertProfile/VerifyStatus.js
// module id = 461
// module chunks = 2 16